module.exports = __webpack_public_path__ + "img/ad2984b.png";